import continueSequence from './continueSequence.middleware';

export default [continueSequence];
